import { createStateSelectorHook } from 'src/lib/sweetState';
import { PerformanceStore } from 'src/store';

const usePerformanceState = createStateSelectorHook(PerformanceStore, [
  'isLoadingUserAccounts',
  'isLoadingWorkspaceAccounts',
  'accountsSortField',
  'accountsSortDirection',
  'connectingToChannelMap',
]);

export const useViewState = (channel) => {
  const {
    isLoadingUserAccounts,
    isLoadingWorkspaceAccounts,
    accountsSortField,
    accountsSortDirection,
    connectingToChannelMap,
  } = usePerformanceState();

  return {
    isLoadingUserAccounts,
    isLoadingWorkspaceAccounts,
    accountsSortField,
    accountsSortDirection,
    connectingToChannel: connectingToChannelMap[channel] || false,
  };
};
